import { atom } from 'jotai';
import { atomWithImmer } from 'jotai-immer'
import dayjs from 'dayjs';

export const defaultDateRange = { from: dayjs().subtract(4, 'weeks').startOf('day'), to: dayjs().endOf('day') };

export const mapState = atom([]);

export const currentUserState = atom();

export const userNameState = atom((get) => get(currentUserState)?.username);

export const deviceInfoState = atom(null);

export const allScanDataState = atom([]);

export const dateRangeState = atom(defaultDateRange);

export const isAdminState = atom(false);

export const massSpectrometryTableDataState = atomWithImmer([]);

export const massSpectrometryResultsDataState = atomWithImmer({});

export const clientCodesState = atomWithImmer([]);

export const massSpectrometryTableExpandedRowState = atom([]);

export const traceMapState = atomWithImmer([]);

export const isSubstanceInfoModalOpenState = atom(false);

export const infoModalSubstanceState = atom(null);

export const allSubstancesDataState = atom([]);

export const currentMassSpecIDState = atom(null);

export const massSpecTourOpenState = atom(false);

export const isImageModalOpenState = atom(false);

export const isNewRecordCreatedState = atom(false);

export const imageFilenameState = atom(null);

export const isInspectionModalOpenState = atom(false);

export const inspectionModalFeedState = atom(null);

export const imageInfoSerialState = atom(null);

export const isTestInfoModalOpenState = atom(false);

export const riskAwarenessShouldUpdateState = atom(false);

export const isOperatorModalOpenState = atom(false);

export const operatorsState = atom([]);

export const operatorsMapState = atom({});

export const currentOperatorState = atom(null);

export const expectedSubstancesState = atom([]);

export const mapReprocessTriggerState = atom(false);

export const wifiCharacteristicState = atom(null);

export const bluetoothServiceState = atom(null);

export const showArchivedScansState = atom(false);

export const imageCharacteristicState = atom(null);

export const userGroupsState = atom([]);

export const viewingRiskAwarenessSampleState = atom(false);

export const loadingResultsState = atom(false);

export const isAllPredictionsPanelOpenState = atom(false);

export const currentSerialState = atom(null);

export const loadingMapState = atom(false);

export const mapScalePercentFilterState = atom([]);

export const selectedSubstanceForMapFilterState = atom(null);

export const mapFilterByMLState = atom(false);

export const isValidatedSpectraTableOpenState = atom(false);

export const currentMapIDState = atom(null);

export const validatedSpectraDataState = atomWithImmer([]);

export const isResultOptionsPanelOpenState = atom(false);

export const userTraceDetectionPreferencesState = atom(null);

export const currentTraceDetectionPreferencesState = atom(null);

export const traceOptionsReadyState = atom(false);